export enum Path {
  ACCOUNTS_MANANGER = '/admin/accounts_manager',
  USERS_MANAGER = '/admin/users_manager',
  LICENSES_MANAGER = '/admin/licenses_manager',
  PRODUCTS_MANAGER = '/admin/products_manager',
  RESOURCES_MANAGER = '/admin/resources_manager',
  DOCUMENTATIONS_MANAGER = '/admin/documentation_manager',
  LICENSES = '/licenses',
  DOWNLOADS_HELYX = '/downloads/helyx',
  DOWNLOADS_ELEMENTS = '/downloads/elements',
  DOCUMENTATIONS_HELYX = '/documentation/helyx',
  DOCUMENTATIONS_ELEMENTS = '/documentation/elements',
  RESOURCES = '/resources',
  SUPPORT_HELYX = '/support/helyx',
  SUPPORT_ELEMENTS = '/support/elements',
  SUPPORT_HELYX_TICKET = '/support/helyx/ticket',
  SUPPORT_ELEMENTS_TICKET = '/support/elements/ticket',
  FILE_MANAGER = '/files',
  FAKE_DATA = '/fake-data',
}

export enum AccessControlKeys {
  ACCOUNTS_MANANGER = 'accounts_manager',
  USERS_MANAGER = 'users_manager',
  LICENSES_MANAGER = 'licenses_manager',
  PRODUCTS_MANAGER = 'products_manager',
  RESOURCES_MANAGER = 'resources_manager',
  DOCUMENTATIONS_MANAGER = 'documentations_manager',
  LICENSES = 'licenses',
  DOWNLOADS_HELYX = 'downloads_helyx',
  DOWNLOADS_ELEMENTS = 'downloads_elements',
  DOCUMENTATIONS_HELYX = 'documentations_helyx',
  DOCUMENTATIONS_ELEMENTS = 'documentations_elements',
  RESOURCES = 'resources',
  SUPPORT_HELYX = 'support_helyx',
  SUPPORT_ELEMENTS = 'support_elements',
  SUPPORT_HELYX_TICKETS = 'support_helyx_tickets',
  SUPPORT_ELEMENTS_TICKETS = 'support_elements_tickets',
  FILE_MANAGER = 'file_manager',
  FAKE_DATA = 'fake_data',
};

export const AccessTable = {
  [Path.ACCOUNTS_MANANGER]: AccessControlKeys.ACCOUNTS_MANANGER,
  [Path.USERS_MANAGER]: AccessControlKeys.USERS_MANAGER,
  [Path.LICENSES_MANAGER]: AccessControlKeys.LICENSES_MANAGER,
  [Path.PRODUCTS_MANAGER]: AccessControlKeys.PRODUCTS_MANAGER,
  [Path.RESOURCES_MANAGER]: AccessControlKeys.RESOURCES_MANAGER,
  [Path.DOCUMENTATIONS_MANAGER]: AccessControlKeys.DOCUMENTATIONS_MANAGER,
  [Path.LICENSES]: AccessControlKeys.LICENSES,
  [Path.DOWNLOADS_HELYX]: AccessControlKeys.DOWNLOADS_HELYX,
  [Path.DOWNLOADS_ELEMENTS]: AccessControlKeys.DOWNLOADS_ELEMENTS,
  [Path.DOCUMENTATIONS_HELYX]: AccessControlKeys.DOCUMENTATIONS_HELYX,
  [Path.DOCUMENTATIONS_ELEMENTS]: AccessControlKeys.DOCUMENTATIONS_ELEMENTS,
  [Path.RESOURCES]: AccessControlKeys.RESOURCES,
  [Path.SUPPORT_HELYX]: AccessControlKeys.SUPPORT_HELYX,
  [Path.SUPPORT_ELEMENTS]: AccessControlKeys.SUPPORT_ELEMENTS,
  [Path.SUPPORT_HELYX_TICKET]: AccessControlKeys.SUPPORT_HELYX_TICKETS,
  [Path.SUPPORT_ELEMENTS_TICKET]: AccessControlKeys.SUPPORT_ELEMENTS_TICKETS,
  [Path.FILE_MANAGER]: AccessControlKeys.FILE_MANAGER,
  [Path.FAKE_DATA]: AccessControlKeys.FAKE_DATA
}